import type { TFunction } from 'i18next'
import type { ControllerConfig, OperationOption, ValueState } from '../../types'

import { Operators } from '@/shared/components/query-builder'

import FieldController from '../Controller'

export default class TextController extends FieldController {
	constructor(config: ControllerConfig) {
		super(config)
		this.note = config.note
		this.validate = config.validate || this.defaultValidate
	}

	note?: string

	formatLabel = () => this.label

	hasValue = ({ operation, value }: ValueState) => {
		if (
			[Operators.IS_EMPTY, Operators.IS_NOT_EMPTY].includes(
				operation as Operators
			)
		) {
			return true
		}

		return Boolean(typeof value === 'string' && value.length)
	}

	getInitialValue = () => ({
		operation: Operators.CONTAINS,
		value: '',
	})

	getFilterTypes = (t: TFunction): OperationOption[] => [
		{
			operation: Operators.CONTAINS,
			label: t('contains.long', { defaultValue: 'contains' }),
			hasInput: true,
		},
		{
			operation: Operators.NOT_CONTAINS,
			label: t('not_contains.long', { defaultValue: 'does not contain' }),
			hasInput: true,
		},
		{
			operation: Operators.IS,
			label: t('is.long', { defaultValue: 'is' }),
			hasInput: true,
		},
		{
			operation: Operators.IS_EMPTY,
			label: t('is_empty.long', { defaultValue: 'is empty' }),
		},
		{
			operation: Operators.IS_NOT_EMPTY,
			label: t('is_not_empty.long', { defaultValue: 'is not empty' }),
		},
	]

	defaultValidate = ({ operation, value }: ValueState, t: TFunction) => {
		if (
			[Operators.IS_EMPTY, Operators.IS_NOT_EMPTY].includes(
				operation as Operators
			)
		) {
			return null
		}
		if (!value || !value.length) {
			return t('validation.provide_text', {
				defaultValue: 'Please provide some text.',
			})
		}

		return null
	}
}
